import React from 'react'
import * as Columns from 'support/columns'
import * as Filters from 'support/filters'
import { ResourceFilter, SelectedDepartmentFilter } from 'support/filters'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Table } from 'widgets/crud'
import { ClearMissingSelectionOnExecute, Collection } from '@morningtrain/react-resources'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import { Translation, Translator, useTranslation } from '@morningtrain/react-translations'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import ViewUserSmartview from 'pages/app/users/partials/smartviews/ViewUserSmartview'
import { Link } from '@morningtrain/react-navigation'
import * as UI from 'ui'

export default function Index () {
  const statusFilterPlaceholder = useTranslation('hr.users.filters.status.placeholder')
  const roleFilterPlaceholder = useTranslation('hr.users.filters.employment_type.placeholder')

  return (
    <AdminPageWithSmartview slideInSmartview>
      <Translator namespace='hr.users'>

        {/* Page header */}
        <UI.PageHeader title={<TranslatedTitle name='title' />}>
          <Link route='app.users.create'>
            <UI.Button>
              <Translation name='actions.create_without_contract' />
            </UI.Button>
          </Link>
        </UI.PageHeader>

        <UI.Card>
          <Collection resourceName='users.users'>
            <ClearMissingSelectionOnExecute />
            <SelectedDepartmentFilter />

            {/* Mount smartview when table item is selected */}
            <MountSmartviewOnSelection smartview={<ViewUserSmartview />} resetOnDeselect replace={false} />

            {/* Header with filters */}
            <UI.TableHeader>
              <Filters.SearchFilter label={<Translation name='filters.search.label' />} />
              <Filters.EnumFilter
                name='status'
                enum='user_status'
                placeholder={statusFilterPlaceholder}
                label={<Translation name='filters.status.label' />}
              />
              <ResourceFilter
                name='employment_type'
                resourceName='employments.employment_type'
                operationName='select'
                optionsKey='name'
                placeholder={roleFilterPlaceholder}
                label={<Translation name='filters.employment_type.label' />}
              />
            </UI.TableHeader>

            {/* Crud table with columns */}
            <Table className='cursor-pointer'>
              <Columns.Avatar/>
              <Columns.Text name="employment_name"/>
              <Columns.Text name="name" label={<Translation name="columns.name"/>}/>
              <Columns.Text name='phone' label={<Translation name='columns.phone.label' />} />
              <Columns.Text name='email' label={<Translation name='columns.email' />} />
            </Table>

            {/* Footer with pagination */}
            <Filters.PaginationFilter />

          </Collection>
        </UI.Card>
      </Translator>
    </AdminPageWithSmartview>
  )
}
